import { UFOODX_BASE_URL } from "../../utils/constants";

import home from "../pages/home";
import login from "../pages/auth/login";
import outlet from "../pages/outlet";
import detailMenu from "../pages/detailMenu";
import detail from "../pages/detail";
import summary from "../pages/summary";
import HistoryList from "../pages/history/list";
import Payment from "../pages/payment";
import Success from "../pages/payment/success";
import VerifyRedirect from "../components/VerifyRedirect";
import Iframe from "../components/Iframe";

const Router = [
  {
    exact: true,
    path: UFOODX_BASE_URL,
    component: home
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/login`,
    component: login
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/menu-detail/:id`,
    component: detailMenu
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/history/detail/:id`,
    component: detail
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/summary`,
    component: summary
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/history/:orderType`,
    component: HistoryList
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/history`,
    component: HistoryList
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/payment`,
    component: Payment
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/payment/success`,
    component: Success
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/verify`,
    component: VerifyRedirect
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/:slug/:type`,
    component: outlet
  },
  {
    exact: true,
    path: `${UFOODX_BASE_URL}/loyalty`,
    component: Iframe
  }
];

export default Router;
